/**
 *  DashBoardModules actions
 */
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { DashboardModuleKey } from '@app/components/xux-dnd/types';
import { IAction } from '@app/shared/types';
import { IAppState } from '@app/store/reducers';
import { IXuxDndCacheModuleData } from '@app/store/reducers/dashboard-cache/xux-dnd-cache.type';
import { get } from 'lodash';

@Injectable()
export class XuxDndCacheActions {
  public static SET_CACHE_ITEM: string = 'SET_CACHE_ITEM';

  public constructor(private ngRedux: NgRedux<IAppState>) {}
  /**
   * SET_CACHE_ITEM action creator.
   */
  public static setCacheItemAction(
    key: DashboardModuleKey,
    value: IXuxDndCacheModuleData,
  ): IAction {
    return {
      type: XuxDndCacheActions.SET_CACHE_ITEM,
      payload: { key, value },
    };
  }

  public dispatchSetCacheItemAction(
    key: DashboardModuleKey,
    value: IXuxDndCacheModuleData,
  ) {
    this.ngRedux.dispatch(XuxDndCacheActions.setCacheItemAction(key, value));
  }

  public getCachedValueByKey(key: DashboardModuleKey): IXuxDndCacheModuleData {
    const state = this.ngRedux.getState();
    if (get(state, 'xuxDndCache') && get(state, ['xuxDndCache', key])) {
      return state.xuxDndCache[key];
    }

    return null;
  }
}
